module.exports = __webpack_public_path__ + "static/media/refund.07513aec.png";